module.exports = __webpack_public_path__ + "img/header-diamondJewelryBracelets.65ed9e9.jpg";